module.exports = __webpack_public_path__ + "6a7da2986b7846bfc47d0e0b6b316e70.png";